import type { ReactNode } from 'react';

export function Placeholder({ title, crumb, phase, children }: { title: string; crumb: string; phase: string; children?: ReactNode }) {
  return (
    <div>
      <div className="mb-4">
        <div className="text-[11px] text-muted mb-1.5">{crumb}</div>
        <h1 className="text-[21px] text-navy tracking-[-0.3px]">{title}</h1>
      </div>
      <div className="bg-card border border-line rounded-card shadow-sh p-10 text-center text-muted">
        <div className="text-[38px] opacity-40 mb-2">◇</div>
        <p className="text-[13px]">
          <b className="text-navy">{title}</b> — scaffolded shell. Full build lands in <b>{phase}</b>.
        </p>
        {children}
      </div>
    </div>
  );
}
